class AmbassadorFilter extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  #handleClick = (event) => {
    const button = event.target.closest('[data-ambassador-filter]');
    if (!button || !this.contains(button)) return;

    const filter = button.dataset.ambassadorFilter;
    const section = this.closest('.arca-ambassadors');
    if (!section) return;

    this.querySelectorAll('[data-ambassador-filter]').forEach((item) => {
      const isActive = item === button;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-pressed', String(isActive));
    });

    section.querySelectorAll('[data-ambassador-card]').forEach((card) => {
      card.hidden = filter !== 'all' && card.dataset.ambassadorRole !== filter;
    });
  };
}

if (!customElements.get('ambassador-filter')) {
  customElements.define('ambassador-filter', AmbassadorFilter);
}

class AmbassadorApplication extends HTMLElement {
  connectedCallback() {
    this.dialog = document.getElementById(this.dataset.dialogId);
    if (!this.dialog) return;

    this.openButton = this.querySelector('[data-ambassador-application-open]');
    this.closeButton = this.dialog.querySelector('[data-ambassador-application-close]');
    this.openButton?.addEventListener('click', this.#open);
    this.closeButton?.addEventListener('click', this.#close);
    this.dialog.addEventListener('click', this.#handleBackdropClick);
  }

  disconnectedCallback() {
    this.openButton?.removeEventListener('click', this.#open);
    this.closeButton?.removeEventListener('click', this.#close);
    this.dialog?.removeEventListener('click', this.#handleBackdropClick);
  }

  #open = () => this.dialog?.showModal();
  #close = () => this.dialog?.close();
  #handleBackdropClick = (event) => {
    if (event.target === this.dialog) this.dialog.close();
  };
}

if (!customElements.get('ambassador-application')) {
  customElements.define('ambassador-application', AmbassadorApplication);
}
